
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ScoreTypeInterface, ScoreTypeRepositoryInterface } from '@/services/QC-V2/score-type/interfaces';
import { DataTableHeader } from 'vuetify';
import { ScoreGradeInterface, ScoreGradeRepositoryInterface } from '@/services/QC-V2/score-grade/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'scoreTypeRepositoryV2',
    'scoreGradeRepositoryV2',
  ],
})
export default class AllScoreTypes extends Vue {
  private scoreTypeRepositoryV2!: ScoreTypeRepositoryInterface;
  private scoreGradeRepositoryV2!: ScoreGradeRepositoryInterface;

  private scoreTypes: ScoreTypeInterface[] = [];
  private scoreGrades: ScoreGradeInterface[] = [];

  private loading: boolean = true;

  private typeHeaders: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Label', value: 'label' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private gradeHeaders: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Label', value: 'label' },
    { text: 'Value', value: 'value' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      this.scoreTypes = await this.scoreTypeRepositoryV2.getAll();
      this.scoreGrades = await this.scoreGradeRepositoryV2.getAll();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }

  private async createScoreType(): Promise<void> {
    await this.$router.push({ name: 'create_score_type' });
  }

  private async editScoreType(id: number): Promise<void> {
    await this.$router.push({ name: 'update_score_type', params: { scoreTypeId: String(id) } });
  }

  private async createScoreGrade(): Promise<void> {
    await this.$router.push({ name: 'create_score_grade' });
  }

  private async editScoreGrade(id: number): Promise<void> {
    await this.$router.push({ name: 'update_score_grade', params: { scoreGradeId: String(id) } });
  }
}
